import React from 'react'
import './About.css';

function About() {
    return (
        <div className='About-container'>
            <h1 style={{padding:'12px'}}>About</h1>
            <div className='resume-container'>
                <div className='objective-container'>
                    <div className='heading'><h1>Objective</h1></div>
                    <div className='answer-container'><p style={{ fontWeight: '100px',width:'100%' }}>Looking for a role where I can use my web design and
                        development skills. I'm a recent graduate with a solid
                        understanding of HTML, CSS, and JavaScript. Excited to
                        contribute to dynamic projects while learning and growing
                        in the field.</p></div>
                </div>
                <div className='st-container'>
                    <div className='heading'><h1>Skills</h1></div>
                    <div className='answer-container flex-con'>
                        <h3>Proficient in HTML, CSS, and JavaScript</h3>
                        <h3>Python</h3>
                        <h3>ReactJs</h3>
                        <h3>NodeJs</h3>
                        <h3>Sql</h3>
                        <h3>Mysql</h3>
                        <div style={{ margin: '12px' }}>Tool</div>
                        <h3>Visual studio code</h3>
                        <h3>Git/Github</h3>
                        <h3>Mysql workbench</h3>
                        <h3>Postman</h3>
                        <h3>Figma</h3>
                    </div>
                </div>
                <div className='Eduction-container'>
                    <div className='heading'><h1>Education</h1></div>
                    <div className='answer-container'>
                        <div style={{padding:'12px',border:'1px solid white',margin:'6px'}}>
                            <h1>Secondary School Certificate (SSC)</h1>
                            <p>Shree Sanatan Dharam Vidyalaya High school and junior college</p>
                            <div>
                                <p>2017 - 2018</p>
                                <p>Mumbai Maharashtra</p>
                            </div>
                            <div>I achieved a percentage of 81.60%</div>
                        </div >
                        <div style={{padding:'12px',border:'1px solid white',margin:'6px'}}>
                            <h1>Higher Secondary Certificate</h1>
                            <p>Shree Sanatan Dharam Vidyalaya High school and junior college</p>
                            <div>
                                <p>2019 - 2020</p>
                                <p>Mumbai Maharashtra</p>
                            </div>
                            <div>I achieved a percentage of 81.60%</div>
                        </div>
                        <div style={{padding:'12px',border:'1px solid white',margin:'6px'}}>
                            <h1>B.Sc information technology -
                                (Mumbai University)</h1>
                            <p>Vivekanand Education Society's College of
                                Arts, Scienece & Commerce
                            </p>
                            <div>
                                <p>2020 - 2023</p>
                                <p>Mumbai Maharashtra</p>
                            </div>
                            <div>I achieved a cgpa of 7.53</div>
                        </div>
                    </div>
                </div>
                <div className='project-container'>
                    <div className='heading'><h1>Projects</h1></div>
                    <div className='answer-container'>
                        <div style={{ top: '49px' }}>
                            <h1>Online sports center</h1>
                            <p>2022-2023</p><p>Mumbai</p>
                            <a href=''>Porject link</a>
                            <div>
                                <ul>
                                    <li>Developed "Online Sports Center" web app using React.js for
                                        frontend and Node.js for backend.
                                    </li>
                                    <li>
                                        Implemented user authentication and seller dashboard for sports
                                        product categorization.
                                    </li>
                                    <li>
                                        Admin categorized products by sports; exposed via REST API for
                                        customer viewing.
                                    </li>
                                    <li>
                                        Enabled customer product selection, automated price calculation,
                                        and flexible payment options for secure delivery.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='certificate-container'>
                    <div className='heading'><h1>Certificate</h1></div>
                    <div className='answer-container'>
                        <div>
                            <ul>
                                <li>Python Programming for Begin</li>
                                <li>Frontend End Develp</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About
